module.exports = __webpack_public_path__ + "static/img/img_home_pt_ys.dc0c46a2.png";